export default __webpack_public_path__ + "static/media/mountain_climber_thumb.68c065b4.png";